const CheckBox = ({ number, checked, setChecked }) => {
  return (
    <div>
        <label>{number}</label>
        <input
            type="checkbox"
            checked={checked}
            onChange={(e) => setChecked(number, e.target.checked)}
          />
    </div>
  );
}

export default CheckBox;